import { queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { obtenerMisEstadisticas } from "../services/estadisticas-service";

/**
 * Query del dashboard · `useQuery` no `useSuspenseQuery` porque queremos
 * mostrar skeletons inline en los stat cards sin bloquear el render del
 * resto del dashboard (salud, acciones rápidas, branding).
 *
 * Polling cada 30s · refresca de fondo. `staleTime: 0` para que un
 * `invalidateQueries` después de crear/autorizar una solicitud refresque
 * inmediatamente.
 */
export const misEstadisticasQueryOptions = queryOptions({
  queryKey: qk.misEstadisticas,
  queryFn: obtenerMisEstadisticas,
  refetchInterval: 30_000,
  refetchOnWindowFocus: true,
  staleTime: 0,
});

export function useMisEstadisticas() {
  return useQuery(misEstadisticasQueryOptions);
}
